<template>
  <div :class="{ 'is-loading': loading }">
    <div class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
// import axios from "axios";

/**
 * Preloader component
 */
export default {
  computed: {
    loading() {
      return this.$store.state.layout.loader;
    },
  },
  mounted() {
    if (!this.loading) {
      [...document.getElementsByClassName("preloader-component")].forEach(
        (elem) => {
          elem.style.display = "none";
        }
      );
      [...document.getElementsByClassName("status")].forEach((elem) => {
        elem.style.display = "none";
      });
    } else {
      [...document.getElementsByClassName("preloader-component")].forEach(
        (elem) => {
          elem.style.display = "block";
        }
      );
      [...document.getElementsByClassName("status")].forEach((elem) => {
        elem.style.display = "block";
      });
    }
  },
  watch: {
    loading: function () {
      if (!this.loading) {
        [...document.getElementsByClassName("preloader-component")].forEach(
          (elem) => {
            elem.style.display = "none";
          }
        );
        [...document.getElementsByClassName("status")].forEach((elem) => {
          elem.style.display = "none";
        });
      } else {
        [...document.getElementsByClassName("preloader-component")].forEach(
          (elem) => {
            elem.style.display = "block";
          }
        );
        [...document.getElementsByClassName("status")].forEach((elem) => {
          elem.style.display = "block";
        });
      }
    },
  },
};
</script>

<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2a3042;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>